'use strict';

import React from 'react';
import flux from 'utils/flux';
import imgAsync from 'img-async';
import Immutable from 'immutable';
import isEqual from 'lodash/lang/isEqual';
import api from 'utils/api';
import dom from 'utils/dom';
import classnames from 'classnames';
import VideoPreviewPlayer from './videoPreviewPlayer';
import ImagePreviewPlayer from './imagePreviewPlayer';
import _cloneDeep from 'lodash/lang/cloneDeep';
import _ from 'lodash';

var Thumb = React.createClass({

    displayName: 'Thumb',

    propTypes: {
        media:     React.PropTypes.object.isRequired,
        className: React.PropTypes.string,
        isBasketItem: React.PropTypes.bool,
        isSharedItem: React.PropTypes.bool
    },

    contextTypes: {
        router: React.PropTypes.func.isRequired
    },

    getInitialState() {
        return {
            previewImages: false,
            previewVideo:  false
        };
    },

    shouldComponentUpdate( nextProps, nextState ) {
        return ( Immutable.is( nextProps.media, this.props.media ) === false || isEqual( nextState, this.state ) === false );
    },

    /**
     * Opens the video modal on click
     */
    openMediaModal( e ) {
        e.preventDefault();
        this.prepareMediaForOpening(this.props.isBasketItem, this.props.isSharedItem);
        setTimeout( () => {
            flux.getActions('media').openCurrentMedia(this.props.media.get('id'));
        }, 10 );
    },

    prepareMediaForOpening(isBasketItem, isSharedItem) {
        if (isBasketItem) {
            flux.getActions('media').cloneMediaAndMetaToModalDataFromBasket(flux.getStore('basket').getState().basket);
            flux.getActions('media').cloneSlotDefinitionsToModalDataFromBasket(flux.getStore('basket').getState().slotDefinitions);
        }
        else if (isSharedItem) {
            flux.getActions('media').cloneMediaAndMetaToModalDataFromShared(flux.getStore('share').getState().baskets);
            flux.getActions('media').cloneSlotDefinitionsToModalDataFromShared(flux.getStore('share').getState().slotDefinitions);
        }
        else {
            flux.getActions('media').cloneMediaAndMetaToModalData();
        }
    },

    /**
     * Decides wheter we should go for a preview slideshow or preview video
     */
    startPreview() {
        // On touch devices do nothing
        if ( Modernizr && Modernizr.touchevents ) {
            return;
        }

        // On non-touch devices lets go for the best option
        if ( this.props.media.get('hoverImages').size !== 0 ) {
            this.setState({
                'previewImages': true
            });
        } else if ( this.props.media.get('hoverVideos').size !== 0 ) {
            this.setState({
                'previewVideo': true
            });
        }
    },

    /**
     * Fallback to the main preview image
     */
    stopPreview() {
        this.setState( this.getInitialState() );
    },

    // Clear Timeout on unmount
    componentWillUnmount() {
        var image = React.findDOMNode(this.refs.image);
        if (image) {
            image.removeEventListener( 'error', this._onImageError );
        }
    },

    _onImageError() {
        var media = this.props.media.toJS();
        var image =  React.findDOMNode(this.refs.image);
        image.src = this.state.previewSlideUrl ? this.state.previewSlideUrl : media.overview ? media.overview.src : Array.isArray(media.thumbnails) ? media.thumbnails[0].preview.src : media.thumbnails.preview.src;
        dom.addClass( image, 'image--loaded' );
        dom.addClass( image, 'image--error' );
    },

    componentDidMount() {
        this.resolveImages();
    },
    componentWillReceiveProps() {
        //this.resolveImages();
    },

    resolveImages() {
        var image = React.findDOMNode(this.refs.image);
        var media = this.props.media.toJS();
        var imageSrc = api.cachedImagePath( this.state.previewSlideUrl ? this.state.previewSlideUrl : media.overview ? media.overview.src : Array.isArray(media.thumbnails) ? media.thumbnails[0].preview.src : media.thumbnails.preview.src );
        imgAsync( imageSrc ).then( function() {
            if ( Modernizr && Modernizr.objectfit ) {
                dom.addClass( image, 'image--loaded' );
            }
            else {
                // Polyfill for object-fill: contain
                image.parentNode.style.backgroundImage    = 'url(' + image.src + ')';
            }
        }, this._onImageError );
    },

    /**
     * Render the video preview if we have hover videos
     */
    renderVideoPreviewPlayer() {
        if ( this.props.media.get('hoverVideos').size === 0 ) {
            return;
        }

        var media = this.props.media.toJS();
        var imageSrc = api.cachedImagePath( this.state.previewSlideUrl ? this.state.previewSlideUrl : Array.isArray(media.thumbnails) ? media.thumbnails[0].preview.src : media.thumbnails.preview.src );

        return (
            <VideoPreviewPlayer show={this.state.previewVideo} poster={imageSrc} videos={this.props.media.get('hoverVideos')}/>
        );
    },

    /**
     * Render the image player preview if we have hover images
     */
    renderImagePreviewPlayer() {
        if ( this.props.media.get('hoverImages').size === 0 ) {
            return;
        }

        var media = this.props.media.toJS();
        var imageSrc = api.cachedImagePath( this.state.previewSlideUrl ? this.state.previewSlideUrl : Array.isArray(media.thumbnails) ? media.thumbnails[0].preview.src : media.thumbnails.preview.src );

        return (
            <ImagePreviewPlayer show={this.state.previewImages} poster={imageSrc} images={this.props.media.get('hoverImages')}/>
        );
    },

    render() {
        var media = this.props.media.toJS();
        var image = media.overview ? media.overview : Array.isArray(media.thumbnails) ? media.thumbnails[0].preview : media.thumbnails.preview;
        var external = media.external;
        if(external) {external = <div className="external">
          <img src="/images/external.png"/>
        </div> }
        var imageSrc = api.cachedImagePath( this.state.previewSlideUrl ? this.state.previewSlideUrl : image.src );

        return (
            <div
                className={classnames( 'thumbnail--asset', this.props.className, {'active': this.state.previewImages || this.state.previewVideo} )}
                onClick={this.props.onClickOpenModal ? this.openMediaModal : null}
                onMouseEnter={this.startPreview}
                onMouseLeave={this.stopPreview}
            >
                <div className="preview__image">
                    <img className="image__static" ref="image" src={imageSrc} width={image.width} height={image.height} />
                    {this.renderVideoPreviewPlayer()}
                    {this.renderImagePreviewPlayer()}
                    { external }
                </div>
                {this.props.children}
            </div>
        );
    }
});

module.exports = Thumb;



// WEBPACK FOOTER //
// ./app/components/thumb/index.jsx